// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-intro__container {
    background-image: linear-gradient(var(--app-fill-login-color-bottom), var(--app-fill-login-color-top));
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    z-index: 1;
    margin: 0;
    min-height: 100vh;
    height: 100%;
    overflow: hidden;
}
.company-intro__loading.MuiLinearProgress-root {
    width: 165px;
    height: 2px;
    margin-top: 15px;
}
.company-intro__loading.MuiLinearProgress-root .MuiLinearProgress-bar.MuiLinearProgress-barColorPrimary {
    background-color: var(--app-fill-color-primary-one);
}
.company-intro__loading.MuiLinearProgress-colorPrimary {
    background-color: white;
}
.company-intro__logo {
    margin: 0 auto;
}

.company-intro__container--desktop {
    padding-top: 0;
    position: static;
    align-items: center;
    background-image: linear-gradient(var(--app-fill-login-color-top), var(--app-fill-login-color-bottom));
    overflow: hidden;
    background-repeat: no-repeat, no-repeat, no-repeat;
}

.company-intro__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.company-intro__logo-bg--desktop {
    position: fixed;
    width: 100%;
    height: auto;
}

.company-intro__logo-bg--mobile {
    position: absolute;
    width: auto;
    top: 8px;
    height: 95%;
}

.company-intro__logo-loading-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.tty-logo--always-visible {
    display: block !important;
}
`, "",{"version":3,"sources":["webpack://./src/core/components/Intro/styles/Intro.css"],"names":[],"mappings":"AAAA;IACI,sGAAsG;IACtG,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,mDAAmD;AACvD;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,sGAAsG;IACtG,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".company-intro__container {\n    background-image: linear-gradient(var(--app-fill-login-color-bottom), var(--app-fill-login-color-top));\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    position: absolute;\n    z-index: 1;\n    margin: 0;\n    min-height: 100vh;\n    height: 100%;\n    overflow: hidden;\n}\n.company-intro__loading.MuiLinearProgress-root {\n    width: 165px;\n    height: 2px;\n    margin-top: 15px;\n}\n.company-intro__loading.MuiLinearProgress-root .MuiLinearProgress-bar.MuiLinearProgress-barColorPrimary {\n    background-color: var(--app-fill-color-primary-one);\n}\n.company-intro__loading.MuiLinearProgress-colorPrimary {\n    background-color: white;\n}\n.company-intro__logo {\n    margin: 0 auto;\n}\n\n.company-intro__container--desktop {\n    padding-top: 0;\n    position: static;\n    align-items: center;\n    background-image: linear-gradient(var(--app-fill-login-color-top), var(--app-fill-login-color-bottom));\n    overflow: hidden;\n    background-repeat: no-repeat, no-repeat, no-repeat;\n}\n\n.company-intro__wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.company-intro__logo-bg--desktop {\n    position: fixed;\n    width: 100%;\n    height: auto;\n}\n\n.company-intro__logo-bg--mobile {\n    position: absolute;\n    width: auto;\n    top: 8px;\n    height: 95%;\n}\n\n.company-intro__logo-loading-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.tty-logo--always-visible {\n    display: block !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
